import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../../cms-structure/page/component/page-component.module';
import { CountrySelectorModule } from '../country-selector';
import { FooterNavigationComponent } from './footer-navigation.component';

@NgModule({
  declarations: [FooterNavigationComponent],
  imports: [
    NzIconModule,
    CommonModule,
    CountrySelectorModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: FooterNavigationComponent,
        },
      },
    }),
    PageComponentModule.forRoot(),
  ],
  providers: [],
  exports: [],
})
export class FooterNavigationModule {}
